<template>
  <div id="m0-check-list-items">
    <div class="m0-check-list-items-header">
      <div class="vx-col w-1/2 flex items-start justify-start edited-user-area">
        <span v-if="editedUserName" class="sdf-text-16-400-white" >入力者情報 : {{ editedUserName }}</span>
      </div>
      <div class="vx-col w-1/2 flex items-center justify-end">
        <div v-if="editHistoryList.length > 0" class="revision-list">
          <vs-dropdown vs-trigger-click class="dropdown">
            <div class="flex">
              <div class="vx-col w-5/6 flex items-center justify-start">
                <span class="sdf-text-16-400-white">{{ selectedEditHistoryName }}</span>
              </div>
              <div class="vx-col w-1/6 flex items-center justify-end">
                <feather-icon icon="TriangleIcon" svgClasses="fill-current h-4 w-4" class="allow-down" />
              </div>
            </div>

            <vs-dropdown-menu class="revision-list-dropdown-menu">
              <vs-dropdown-item v-for="(editHistory, index) in editHistoryList" :key="index" @click="onChangeEditHistory(editHistory)">
                <span class="sdf-text-16-400-white">{{ editHistory.userName }} {{ convertDateTimeString(editHistory.savedAt) }} </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
    </div>
    <div class="m0-check-list-items-main">
      <div v-for="(item, index) in items" :key="index">
        <!-- group_nameが ひとつ前と違えば見出しとして表示 -->
        <div v-if=" index === 0 || ( index > 0 && items[index-1].group_id != items[index].group_id )" 
              class="m0-check-list-items-list-group" >
          <div class="group-title">
            <span class="sdf-text-18-700-white">{{item.group_name}}</span>
          </div>
        </div>

        <div class="m0-check-list-items-list flex">
          <div class="vx-col w-1/2 flex items-center justify-start">
            <span class="sdf-text-18-400-white">{{ item.item_name }}</span>
          </div>
          <div class="vx-col w-1/6 flex items-center justify-end">
            <span class="sdf-text-16-400-white">{{ item.value_normal ? item.value_normal.replace('||', '〜') : "" }}</span>
          </div>
          <div class="vx-col w-1/6 flex items-center justify-end">
            <span class="sdf-text-18-400-white">{{ item.value_number || item.value_string }}</span>
          </div>
          <div class="vx-col w-1/6 flex items-center justify-end">
            <span class="sdf-text-18-400-white">{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin"
import {createNamespacedHelpers} from "vuex"
const { mapGetters, mapActions, mapState } = createNamespacedHelpers("m0CheckListReport")
import moment from "moment";

export default {
  name: "M0CheckListDetails",
  mixins: [SecureDataflowMixin],
  props: [
    "items",
  ],
  data() {
    return {
      selectedEditHistoryName: "編集履歴",
    }
  },
  computed: {
    ...mapGetters(["getSelectedRoomId", "getEditHistoryListMap", "getSelectedEditHistoryId"]),
    ...mapState({
      selectedM0CheckListId: state => state.selectedM0CheckListId,
      selectedRoomId: state => state.selectedRoomId,
    }),
    editedUserName() {
      let editHistoryList = this.getEditHistoryListMap[this.selectedRoomId];
      if ( this.getSelectedEditHistoryId >= 0 && editHistoryList ) {
        let editHistory = editHistoryList.find(editHistory => editHistory.editHistoryId === this.getSelectedEditHistoryId);
        if ( editHistory ) {
          return editHistory.userName;
        }
      }
    },
    editHistoryList() {
      let editHistoryListMap = this.getEditHistoryListMap;
      let editHistoryList = editHistoryListMap[this.getSelectedRoomId];
      return editHistoryList ? editHistoryList : [];
    }
  },
  watch: {
    selectedM0CheckListId() {
      this.selectedEditHistoryName = "編集履歴";
      if ( this.selectedM0CheckListId && this.selectedM0CheckListId >= 0 ) {
        this.$nextTick(function () {
          document.getElementsByClassName("m0-check-list-items-main").forEach(element => {
            element.scrollTop = 0;
          });
        });
      }
    },
    selectedRoomId() {
      this.selectedEditHistoryName = "編集履歴";
      if ( this.selectedRoomId && this.selectedRoomId >= 0 ) {
        this.$nextTick(function () {
          document.getElementsByClassName("m0-check-list-items-main").forEach(element => {
            element.scrollTop = 0;
          });
        });
      }
    },
  },
  methods: {
    ...mapActions(["setSelectedEditHistoryId"]), 
    
    convertDateTimeString: function(timeValue){
      return moment.utc(timeValue).local().format("YYYY/MM/DD HH:mm");
    },
    onChangeEditHistory: async function(editHistory) {
      this.setSelectedEditHistoryId(editHistory.editHistoryId);
      this.selectedEditHistoryName = this.convertDateTimeString(editHistory.savedAt);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/secure-dataflow/_variables.scss";

#m0-check-list-items {
  background-color: $sdf-dark-blue-navy;
  color: $sdf-white;

  .m0-check-list-items-header {
    width: 100%;
    display: flex;
    padding: 1rem;
    border-bottom: solid;
    border-width: 1px;
    border-color: $sdf-gray;

    .edited-user-area {
      padding: 0.5rem;
    }
  }

  .m0-check-list-items-list-group {
    padding: 0.8rem 1rem 0.8rem 0.2rem;
    border-bottom: solid;
    border-width: 1px;
    border-color: $sdf-gray;
  }

  .m0-check-list-items-list {
    padding: 0.8rem 1rem 0.8rem 0.8rem;
    border-bottom: solid;
    border-width: 1px;
    border-color: $sdf-gray;
  }

  .m0-check-list-items-main {
    width: 100%;
    height: calc(100vh - 260px);
    overflow-y: auto;
    scrollbar-color: $sdf-gray $sdf-dark-blue-navy;
    padding-right: 0.5rem;
  }

  .revision-list {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;

    .allow-down > svg{
      transform: rotate(180deg);
      color: $sdf-navy;
    }

    .dropdown {
      height: 36px;
      min-width: 300px;
      border: 2px solid $sdf-navy;
      border-radius: 3px;
      padding: 1px 10px 1px 10px;
    }
  }

  .group-title {
    padding-left : 10px;
    border-left: solid 4px;
    border-left-color: $sdf-blue;
  }
}

.vs-dropdown--item {
  border: 6px solid $sdf-navy;
  border-radius: 0;
  color: $sdf-white;
  background: $sdf-navy;
  width: 360px;
  margin: 0;
}

.revision-list-dropdown-menu {
  :hover {
    background: $sdf-blue;
  }
}

</style>
